import {DrmTypeVo} from '../../common/shared/api/nicolas/vo/enums/DrmTypeVo.enum';
import {DrmType} from '../generated/types';

export function createDrmType(drmTypeVo: DrmTypeVo): DrmType {
  return mapper[drmTypeVo];
}

const mapper: {[key in DrmTypeVo]: DrmType} = {
  [DrmTypeVo.None]: DrmType.None,
  [DrmTypeVo.Widevine]: DrmType.Widevine,
  [DrmTypeVo.PlayReady]: DrmType.Playready,
  [DrmTypeVo.Fairplay]: DrmType.Fairplay,
};
